<template>
  <div id="monitoring" :style="{ width: width, height: height }"></div>
</template>
<script>
import * as echarts from 'echarts';
export default {
  data() {
    return {
      charts: '',
      // 指定图表的配置项和数据
      option: {
        title: {
          show: false,
          text: 'Stacked Area Chart',
        },
        tooltip: {
          show: true,
          trigger: 'axis',
          // backgroundColor: 'blue',
          // 让toolltip紧跟鼠标
          // 打开tooltip有可能鼠标移入的时候会出现屏幕抖动情况
          // 设置transitionDuration为0可以解决此问题
          transitionDuration: 0, // 让toolltip紧跟鼠标
          axisPointer: {
            type: 'cross', // 'line' 直线指示器 'shadow' 阴影指示器 'none' 无指示器 'cross' 十字准星指示器。其实是种简写，表示启用两个正交的轴的 axisPointer。
            label: {
              backgroundColor: '#6a7985',
            },
            // crossStyle: { // 横向配置
            //   color: 'blue'
            // },
            // lineStyle: { //纵向配置
            //   color: 'blue'
            // }
          },
        },
        legend: {
          show: false,
          textStyle: {
            color: '#fff',
            fontSize: 13,
          },
          // data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine']
        },
        grid: {
          top: '4%',
          left: '0%',
          right: '4%',
          bottom: '0%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            // name:'(时间)',
            // nameTextStyle: {
            //   color:'#fff',
            //   fontSize:12,
            //   verticalAlign:'top'
            // },
            boundaryGap: false,
            data: [],
            axisTick: {
              show: false,
              alignWithLabel: true,
            },
            axisLine: {
              lineStyle: {
                color: '#0f5681',
              },
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#0f5681',
                type: 'dotted',
              },
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff', //更改坐标轴文字颜色
                fontSize: 12, //更改坐标轴文字大小
              },
            },
          },
        ],
        yAxis: {
          type: 'value',
          // min: 6,
          // max: 9,
          step: 1,
          name: this.yUnit,
          nameTextStyle: {
            color: '#fff',
            fontSize: 12,
            align: 'right',
          },
          axisLine: {
            lineStyle: {
              color: '#0f5681',
            },
          },
          axisTick: {
            show: false,
            alignWithLabel: true,
          },
          splitLine: {
            lineStyle: {
              color: '#0f5681',
              type: 'dashed', // solid dashed dotted
            },
          },
          axisLabel: {
            show: true,
            align: 'right',
            textStyle: {
              color: '#fff', //更改坐标轴文字颜色
              fontSize: 12, //更改坐标轴文字大小
            },
          },
        },
        series: [
          {
            name: '新增商家',
            type: 'line',
            // smooth: true,
            // data: [4, 3, 8, 4, 4, 4, 4, 4],
            data: [],
            lineStyle: {
              color: '#ffc64e',
            },
            itemStyle: {
              // 线和拐点的颜色
              borderColor: '#ffc64e',
              color: '#ffc64e', //图例的颜色
            },
            markLine: {
              label: {
                formatter: '{b}',
              },
              // data: [{ type: 'min', name: '最小值' },{type: 'max', name: '最大值'}],
            },
          },
          {
            name: '新增入驻商街',
            type: 'line',
            // smooth: true,
            // data: [4, 5, 4, 8, 4, 5, 4, 5],
            data: [],
            lineStyle: {
              color: '#01ecf2',
            },
            markLine: {
              label: {
                formatter: '{b}',
              },
              // data: [{ type: 'min', name: '最小值' },{type: 'max', name: '最大值'}],
            },
            itemStyle: {
              // 线和拐点的颜色
              borderColor: '#01ecf2',
              color: '#01ecf2', //图例的颜色
            },
          },
          // {
          //   name: this.name,
          //   type: 'line',
          //   // stack: 'Total',
          //   symbol: 'circle',
          //   symbolSize: 7,
          //   itemStyle: {
          //     // 线和拐点的颜色
          //     borderColor: '#01ecf2',
          //     color: '#0e0b12', //图例的颜色
          //   },
          //   emphasis: {
          //     // focus: 'series',
          //     itemStyle: {
          //       // 移入拐点样式配置
          //       color: '#0e0b12', //图例的颜色
          //       borderColor: '#b08010', //图形的描边颜色
          //       // borderWidth: 2, // 描边的线宽
          //       // shadowBlur: 5, // 图形的阴影大小
          //       // shadowColor: '#F70938' // 图形的阴影颜色
          //     },
          //   },
          //   areaStyle: {
          //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          //       { offset: 0, color: '#004b85' },
          //       { offset: 0.7, color: '#031233' },
          //       { offset: 1, color: '#031233' },
          //     ]),
          //   },
          //   lineStyle: {
          //     color: '#01ecf2',
          //   },
          //   data: this.yValue,
          // },
        ],
      },
    };
  },
  props: {
    busiinData: {
      type: Array,
      default: [],
    },
    busiData: {
      type: Array,
      default: [],
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '13vw',
    },
    name: {
      type: String,
      default: '检测',
    },
    // xValue: {
    //   type: Array,
    //   default: () => [],
    // },
    yUnit: {
      type: String,
      default: '',
    },
    yValue: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    yValue(newValue) {
      this.drawLine();
    },
  },
  mounted() {
    this.drawLine();
  },
  destroyed() {
    window.removeEventListener('resize', this.selfAdaption);
  },
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      this.charts = echarts.init(document.getElementById('monitoring'));
      this.option.xAxis[0].data = this.busiData.map(x => {return x.Name});
      this.option.series[0].data = this.busiData.map(x => {return x.Value});
      this.option.series[1].data = this.busiinData.map(x => {return x.Value});
      // 使用刚指定的配置项和数据显示图表。
      this.charts.setOption(this.option);
      window.addEventListener('resize', this.selfAdaption);
    },
    refreshData() {
      //刷新数据
      this.charts = echarts.getInstanceByDom(document.getElementById('monitoring'));
      this.option.xAxis[0].data = this.busiData.map(x => {return x.Name});
      this.option.series[0].data = this.busiData.map(x => {return x.Value});
      this.option.series[1].data = this.busiinData.map(x => {return x.Value});
      // var option = this.charts.getOption();
      // option.series[0].data = listData;
      this.charts.setOption(this.option);
    },

    // 自适应
    selfAdaption() {
      if (!this.charts) return;
      this.charts.resize();
      // this.drawLine();
    },
  },
};
</script>
